var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field-info"},[_c('span',{staticClass:"field-info-value"},[_vm._v(_vm._s(_vm.value))]),(_vm.label)?_c('span',{staticClass:"field-info-label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }